import {IconShade} from '../../components/icon/iconColor';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

export interface IconSemanticStyles extends Record<IconShade, string> {}

export const lightIconSemanticStyles: IconSemanticStyles = {
  primary: colorPrimitive.gray['900'],
  secondary: colorPrimitive.gray['700'],
  tertiary: colorPrimitive.gray['500'],
  inverse: colorPrimitive.gray['50'],
  disabled: colorPrimitive.gray['400'],

  info: colorPrimitive.blue['600'],
  success: colorPrimitive.green['600'],
  brand: colorPrimitive.purple['600'],
  danger: colorPrimitive.red['600'],
  warning: colorPrimitive.yellow['400'],

  'on-bg-fill': colorPrimitive.gray.white,
  'on-bg-fill-inverse': colorPrimitive.gray['1000'],
};

export const darkIconSemanticStyles: IconSemanticStyles = {
  primary: colorPrimitive.gray['200'],
  secondary: colorPrimitive.gray['300'],
  tertiary: colorPrimitive.gray['500'],
  inverse: colorPrimitive.gray['900'],
  disabled: colorPrimitive.gray['700'],

  info: colorPrimitive.blue['500'],
  success: colorPrimitive.green['500'],
  brand: colorPrimitive.purple['500'],
  danger: colorPrimitive.red['500'],
  warning: colorPrimitive.yellow['400'],

  'on-bg-fill': colorPrimitive.gray.white,
  'on-bg-fill-inverse': colorPrimitive.gray['1000'],
};
